import dayjs from "dayjs";
import React, { useEffect, useRef, useState } from "react";
import MedicalService from "../Services/MedicalService";
import { HSdecrypt } from "../utils/encryptPassword";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import profile from "../assets/images/ProfileImage.jpg";
import ChronicConditionService from "../Services/ChronicConditionService";
import { QRCodeCanvas } from "qrcode.react";
import { convertUTCDate } from "../utils/convertionFunc";
import { Flex, Modal, Spin } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { MdDownloadForOffline } from "react-icons/md";
import PatientService from "../Services/PatientService";

function EmergencyDataView() {
  const frontRef = useRef();
  const backRef = useRef();
  const [patientQrData, setPatientQrData] = useState();
  const [patDetails, setPatDetails] = useState(null);
  const [chronicConditions, setChronicConditions] = useState([]);
  const [patientAlleryData, setPatientAlleryData] = useState([]);
  const [isLoading, setIsLoading] = useState({
    allergy: false,
    chronics: false,
    drug: false,
  });
  const [medications, setMedications] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isFlipped, setIsFlipped] = useState(false);
  const loggedUserJson = localStorage.getItem("patientData");
  const loggedUser = loggedUserJson ? JSON.parse(loggedUserJson) : null;

  useEffect(() => {
    // setPatDetails(loggedUser);
    PatientAllergies();
    PatientchronicConditions();
    patientMedication();
    getPatientDetails();
    PatientEmergencyData();
  }, []);

  const getPatientDetails = async () => {
    const payload = {
      patientId: loggedUser.patientId,
    };

    try {
      const response = await PatientService.HSPatientData(payload);
      setPatDetails(response.data[0]);
    } catch (e) {
      console.error(e);
    }
  };

  const PatientAllergies = () => {
    setIsLoading((prevState) => ({ ...prevState, allergy: true }));
    let payload = {
      patientCode: loggedUser.patientId,
      status: 1,
    };
    MedicalService.HSPatientAllergyList(payload)
      .then((result) => {
        const decryptedData = HSdecrypt(result.data.data);
        const parsedAllergyData = JSON.parse(decryptedData);
        const filteredDrugAllergies = parsedAllergyData?.map((item) => ({
          drugAllergy: item["drugAllergy"],
        }));
        setPatientAlleryData(filteredDrugAllergies);
        setIsLoading((prevState) => ({ ...prevState, allergy: false }));
      })
      .catch((error) => {
        console.error(error);
        setIsLoading((prevState) => ({ ...prevState, allergy: false }));
      });
  };

  const PatientchronicConditions = () => {
    setIsLoading((prevState) => ({ ...prevState, chronics: true }));
    let payload = {
      patientId: loggedUser.patientId,
    };
    ChronicConditionService.HSPatientchronicConditions(payload)
      .then((result) => {
        const decryptedData = HSdecrypt(result.data.data);
        setChronicConditions(JSON.parse(decryptedData));
        setIsLoading((prevState) => ({ ...prevState, chronics: false }));
      })
      .catch((error) => {
        console.error(error);
        setIsLoading((prevState) => ({ ...prevState, chronics: false }));
      });
  };

  const patientMedication = () => {
    setIsLoading((prevState) => ({ ...prevState, drug: true }));
    let payload = {
      patientCode: loggedUser.patientId,
      status: 1,
    };
    MedicalService.HSPatientMedication(payload)
      .then((result) => {
        const decryptedData = HSdecrypt(result.data.data);
        setMedications(JSON.parse(decryptedData));
        setIsLoading((prevState) => ({ ...prevState, drug: false }));
      })
      .catch((error) => {
        console.error(error);
        setIsLoading((prevState) => ({ ...prevState, drug: false }));
      });
  };

  const handleDownload = async () => {
    const pdf = new jsPDF();
    const frontSide = frontRef.current;
    const backSide = backRef.current;

    if (!frontSide || !backSide) return;

    try {
      backSide.style.display = "none";

      const frontCanvas = await html2canvas(frontSide, {
        scale: 3,
        useCORS: true,
      });
      const frontImage = frontCanvas.toDataURL("image/png");

      frontSide.style.display = "none";
      backSide.style.display = "block";
      backSide.style.transform = "none";
      backSide.style.backfaceVisibility = "visible";

      const backCanvas = await html2canvas(backSide, {
        scale: 3,
        useCORS: true,
      });
      const backImage = backCanvas.toDataURL("image/png");

      frontSide.style.display = "block";
      backSide.style.display = "none";

      const imgWidth = 180;
      const frontHeight = (frontCanvas.height * imgWidth) / frontCanvas.width;
      const backHeight = (backCanvas.height * imgWidth) / backCanvas.width;

      pdf.addImage(frontImage, "PNG", 10, 10, imgWidth, frontHeight);
      pdf.addImage(
        backImage,
        "PNG",
        10,
        20 + frontHeight,
        imgWidth,
        backHeight
      );

      pdf.save("Emergency_MedicalCard.pdf");
    } finally {
      frontSide.style.display = "block";
      backSide.style.display = "block";
      backSide.style.transform = "rotateY(180deg)";
      backSide.style.backfaceVisibility = "hidden";
    }
  };

  const calculateAge = (dob) => {
    const dobData = dob;
    const dobYear = dobData?.split("/")[2];
    const currYear = new Date().getFullYear();
    if (dobYear) {
      const patientAge = currYear - Number(dobYear);
      return patientAge;
    }
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const PatientEmergencyData = () => {
    let patienObject = localStorage.getItem("patientData");
    let patientDataV = patienObject ? JSON.parse(patienObject) : null;
    let payload = {
      status: 1,
      patientId: patientDataV?.patientId,
    };
    MedicalService.PatientQrList(payload).then((result) => {
      if (result?.data[0]?.healthCardUrl) {
        let url =
          "https://doctor-dev.doxzon.com/emergencyqr/" +
          result?.data[0]?.healthCardUrl;
        setPatientQrData(url);
      }
    });
  };

  const generateQRCard = () => {
    let patienObject = localStorage.getItem("patientData");
    let patientDataV = patienObject ? JSON.parse(patienObject) : null;
    let payload = {
      createdBy: patientDataV?.patientId,
      createdDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      modifiedBy: patientDataV?.patientId,
      modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      patientId: patientDataV?.patientId,
      status: 1,
    };
    MedicalService.GenerateQr(payload).then((result) => {
      let url =
        "https://doctor-dev.doxzon.com/emergencyqr/" +
        result?.data?.healthCardUrl;
      PatientEmergencyData();
    });
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const handleCardClick = () => {
    setIsFlipped((prev) => !prev);
  };
  return (
    <div>
      {isLoading.allergy ||
      isLoading.chronics ||
      isLoading.drug ||
      !patDetails ? (
        <div className="h-[300px] flex items-center justify-center mt-[10%]">
          <Flex align="center" gap="middle">
            <Spin size="large" tip="Loading" />
          </Flex>
        </div>
      ) : (
        <div>
          <div className="flex justify-end space-x-4">
            <MdDownloadForOffline
              className="text-blue-600 cursor-pointer font-bold w-6 h-6"
              onClick={handleDownload}
            />
            <CloseOutlined
              className="text-white cursor-pointer"
              onClick={handleCancel}
            />
          </div>
          <div
            className="relative w-full h-[250px] perspective cursor-pointer"
            onClick={handleCardClick}
          >
            <div
              className={`relative w-full h-full transform-style-preserve-3d transition-transform duration-700 ${
                isFlipped ? "rotate-y-180" : ""
              }`}
            >
              <div
                className="absolute w-full backface-hidden border-2 border-slate-200 rounded-lg bg-white"
                ref={frontRef}
              >
                <div className="h-10 bg-[#189FAA] rounded-md flex justify-center items-center">
                  <p className="font-semibold text-center text-base text-white">
                    Emergency Medical Card
                  </p>
                </div>
                <div className="w-full p-2 flex justify-evenly">
                  <div className="flex gap-5 w-[75%]">
                    <div className="w-24 h-25 bg-white border rounded-xl flex items-center justify-center overflow-hidden">
                      {patDetails?.photoNameBase64 ? (
                        <img
                          src={
                            "data:image/jpeg;base64," +
                            patDetails?.photoNameBase64
                          }
                          alt=""
                          className="w-full h-full object-cover rounded-xl"
                        />
                      ) : (
                        <img
                          src={profile}
                          alt=""
                          className="w-full h-full object-cover "
                        />
                      )}
                    </div>
                    <div>
                      <h4 className="text-sm font-medium text-gray-900 mt-2">
                        Name:{" "}
                        <span className="font-bold text-[#189FAA]">
                          {" "}
                          {patDetails?.salutation +
                            " " +
                            patDetails?.firstName +
                            " " +
                            patDetails?.lastName}
                        </span>
                      </h4>
                      <h4 className="text-sm font-medium text-gray-900 mt-2">
                        Age:{" "}
                        <span className="font-bold text-[#189FAA]">
                          {calculateAge(patDetails?.ageDob)}
                        </span>
                      </h4>
                      <h4 className="text-sm font-medium text-gray-900 mt-2">
                        BloodGroup:{" "}
                        <span className="font-bold text-[#189FAA]">
                          {patDetails?.bloodGroup}
                        </span>
                      </h4>
                      <h4 className="text-sm font-medium text-gray-900 mt-2">
                        Mobile No:{" "}
                        <span className="font-bold text-[#189FAA]">
                          {patDetails?.mobile}
                        </span>
                      </h4>
                    </div>
                  </div>
                  <div className="w-[25%]">
                    <div className="w-24 h-24 rounded-lg flex items-center justify-center mt-3 bg-white border">
                      {patientQrData && (
                        <QRCodeCanvas
                          value={patientQrData}
                          size={100}
                          className="mt-2"
                        />
                      )}{" "}
                    </div>
                  </div>
                </div>
                <div className="h-7 bg-red-600 flex items-center justify-center">
                  <p className="text-sm font-semibold text-white">
                    Emergency Contact
                  </p>
                </div>
                <div className="flex justify-evenly items-center my-2">
                  <h6 className="text-xs font-medium">
                    Mobile Number:{" "}
                    <span className="text-sm font-semibold">
                      {patDetails?.emergencyContact}
                    </span>
                  </h6>
                </div>
              </div>
              <div
                className="absolute w-full h-60 backface-hidden rotate-y-180 border-2 border-slate-200 rounded-md"
                ref={backRef}
              >
                <div className="h-10 bg-white-800 rounded-md flex justify-center items-center">
                  <p className="font-semibold text-center text-base text-white"></p>
                </div>
                <div className="p-5">
                  <div className="flex items-center justify-center text-center mt-5">
                    <p className="text-sm font-semibold">
                      Access my personal Health Records At:
                      <br />
                      <a
                        href={`${process.env.REACT_APP_FRONTEND_URL?.replace(
                          /\/$/,
                          ""
                        )}/PHR-ACCESS/${patDetails?.patientId}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-[#189FAA]"
                      >
                        {`${process.env.REACT_APP_FRONTEND_URL.replace(
                          /^https?:\/\//,
                          ""
                        )}PHR-ACCESS`}
                      </a>
                    </p>
                  </div>
                  <div className="flex justify-center items-center gap-10">
                    <div>
                      <p className="text-sm font-semibold">
                        MEMBER ID:{" "}
                        <span className="text-sm font-bold text-[#189FAA]">
                          {patDetails?.patientId}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default EmergencyDataView;
